import { render, staticRenderFns } from "./inspectiondetail.vue?vue&type=template&id=7ea4776e&scoped=true"
import script from "./inspectiondetail.vue?vue&type=script&lang=js"
export * from "./inspectiondetail.vue?vue&type=script&lang=js"
import style0 from "./inspectiondetail.vue?vue&type=style&index=0&id=7ea4776e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea4776e",
  null
  
)

export default component.exports